import { render, staticRenderFns } from "./CancelledReservation.vue?vue&type=template&id=2f7a80b2&scoped=true&"
import script from "./CancelledReservation.vue?vue&type=script&lang=js&"
export * from "./CancelledReservation.vue?vue&type=script&lang=js&"
import style0 from "./CancelledReservation.vue?vue&type=style&index=0&id=2f7a80b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a80b2",
  null
  
)

export default component.exports